import { useContext, useEffect, useState } from 'react';

import styles from './AdministratorCardComponent.module.css'

import { ProjectDetailsContext } from '../../../contexts/projectDetailsContext';
import { GlobalContext } from '../../../contexts/globalContext';

import InitialsCircleComponent from '../../commons/InitialsCircleComponent';
import TagComponent from '../../projectList/TagComponent';


const AdministratorCardComponent = ({ user }) => {

    const [isPresenter, setIsPresenter] = useState(false)

    const { editConference } = useContext(ProjectDetailsContext)
    const { socketRef, setAlertMessage } = useContext(GlobalContext)

    useEffect(() => {
        if (user.presentation === editConference._id) {
            setIsPresenter(true)
        }
    }, []);

    const clickHandler = () => {
        if(isPresenter) {
            socketRef.current.emit('CONFERENCE_ASSIGN_QUICK_PRESENTATION_TO_USER', null, user._id,  (data) => {
                if(!data.error) {
                setIsPresenter(false)
                } else {
                    setAlertMessage({ type: "ERROR", message: data.response })
                }
            })
        } else {
            socketRef.current.emit('CONFERENCE_ASSIGN_QUICK_PRESENTATION_TO_USER', editConference._id, user._id,  (data) => {
                if(!data.error) {
                setIsPresenter(true)
                } else {
                    setAlertMessage({ type: "ERROR", message: data.response })
                }
            })
        }
    }

    return (
        <div className={ isPresenter ? styles.selectedComponent :  styles.component} style={{
            transformOrigin: "left top",
        }} onClick={clickHandler}>
            {isPresenter && (
                <div style={{ position: "absolute", top: 40, right: 30 }} > <TagComponent text="PRESENTER" /> </div>
            )}
            <InitialsCircleComponent name={user.name} style={{
                marginLeft: -6, marginTop: -6, height: 121, width: 121,
                border: "6px solid #0D0032", marginBottom: 10, position: 'relative'
            }} />
            <label className={styles.role} style={{ color: isPresenter ? '#33FFC8' : '#EEEEEE' }}>{user.role}</label>
            <label className={styles.name}>{user.name}</label>
        </div>
    );

}

export default AdministratorCardComponent;